import { GeneralConfigs } from "@caju-beneficios/sponsor-v2-lib/dist/configs";
import { EnumProducts } from "@caju-beneficios/sponsor-v2-lib/dist/lib/environment/enumProducts";

GeneralConfigs.init({
  product: EnumProducts.SHARED,
  apiUrl: process.env.REACT_APP_BASE_URL_API || '',
  servicesApiUrl: process.env.REACT_APP_CAJU_SERVICES_URL || '',
  // baseUrls: {
  //   LOGIN: {
  //     DEVELOPMENT: 'https://empresa-v2-staging.caju.com.br/login/',
  //     FEATURE: 'https://empresa-v2-staging.caju.com.br/login/'
  //   },
  //   CLASSIC: {
  //     DEVELOPMENT: 'https://empresa-v2-staging.caju.com.br/classic/',
  //     FEATURE: 'https://adempresa-v2-staging.caju.com.br/classic/'
  //   },
  // }
})
